import { render, staticRenderFns } from "./PaneHeader.vue?vue&type=template&id=fc052b84&scoped=true"
import script from "./PaneHeader.vue?vue&type=script&lang=js"
export * from "./PaneHeader.vue?vue&type=script&lang=js"
import style0 from "./PaneHeader.vue?vue&type=style&index=0&id=fc052b84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc052b84",
  null
  
)

export default component.exports